export default __webpack_public_path__ + "static/launch-396179517dadb29c6494ee74ecb8e6d6.jpg";